<template>
    <v-container grid-list-md class="pa-0">
        <v-layout v-for="(item, index) in value" :key="index" wrap>
            <v-flex xs8>
                <a v-if="!disabled" ref="rec-file" target="_blank" class="blue--text" :href="item">
                    {{ item }}
                </a>
                <template v-else>
                    {{ item }}
                </template>
            </v-flex>
            <v-flex xs4>
                <v-tooltip :right="isRight">
                    <template v-slot:activator="{ on }">
                        <button-app-control
                            ref="copy-btn"
                            :color="color"
                            :icon="'fa-copy'"
                            :disabled="disabled"
                            text
                            @click="$emit('copy-text', value)"
                            v-on="on"
                        />
                    </template>
                    <span>
                        {{ $t('Copy') }}
                    </span>
                </v-tooltip>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import InputValidation from '../../mixins/InputValidation';
import ButtonAppControl from './ButtonAppControl.vue';

@Component({
    name: 'FileItems',
    components: {
        ButtonAppControl,
    },
})
export default class FileItems extends mixins(InputValidation) {
    @Prop({ default: () => [] }) value: Array<string>;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) isRight: boolean;
    @Prop({ default: 'brack' }) color: string;

    path = '';

    /**
     * getter
     */
    get isDisabled(): boolean {
        return this.disabled;
    }
}
</script>
